import { useEffect } from 'react';
import config from 'config';
import { ROUTES } from 'constant';
import { useRouter } from 'next/navigation';

import { Heading, useTheme, VStack } from '@chakra-ui/react';

import { useAppDispatch } from 'store/hooks';
import { setContinueShoppingUrl } from 'store/reducers/cartSlice';

import { Divider, Text } from 'ui';
import { NavigationButtons } from '../NavigationButtons';

const {
  shop: {
    packages: {
      finalStep: { text }
    }
  }
} = config;

interface PackagesFinalStepProps {
  onFinish: () => void;
}

const PackagesFinalStep = ({ onFinish }: PackagesFinalStepProps) => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const {
    colors: {
      palette: {
        shop: {
          packages: { stepFinal }
        }
      }
    }
  } = useTheme();

  const goToPackages = () => {
    router.push(ROUTES.packages);
  };

  const goToDashboard = () => {
    router.push(ROUTES.dashboard);
  };

  useEffect(
    () => () => {
      dispatch(setContinueShoppingUrl(''));
      onFinish();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <VStack textAlign='center' gap={0}>
      <VStack maxWidth='657px' mb='30px' gap={{ base: '28px', md: '32px' }}>
        <Heading
          variant='h1'
          as='h1'
          fontFamily='main'
          fontWeight={400}
          fontSize={{ base: 32, md: 39 }}
          lineHeight={{ base: '43px', md: '53px' }}
          color={stepFinal.heading}
          mb={{ bas: '18px', md: 0 }}
        >
          Thank You!
        </Heading>

        {text.map((item: string) => (
          <Text
            key={item}
            fontSize={{ base: 15, md: 18 }}
            lineHeight={{ base: '28px', md: '32px' }}
          >
            {item}
          </Text>
        ))}
      </VStack>

      <Divider borderColor={stepFinal.divider} />

      <NavigationButtons
        onBackHandler={goToPackages}
        onNextHandler={goToDashboard}
        backLabel='My packages'
        nextLabel='My dashboard'
      />
    </VStack>
  );
};

export default PackagesFinalStep;
